import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import dayjs from "dayjs";
import Select from "react-select";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Badge, Button } from "reactstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ManualInvoiceList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [overallSum, setOverallSum] = useState(0);

    // Filters States
    const [searchInvoice, setSearchInvoice] = useState("");
    const [statusFilter, setStatusFilter] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const limit = 20;

    const statusOptions = [
        { value: "", label: "All Status" },
        { value: "issued", label: "Issued" },
        { value: "paid", label: "Paid" },
        { value: "cancelled", label: "Cancelled" }
    ];

    const loadInvoices = async () => {
        dispatch(loadingTrue());
        
        // Machan, payload-la 'action' field ippo 'list_expenses' trigger pannum
        const payload = {
            action: "list_expenses", 
            page: page,
            limit: limit,
            invoice_number: searchInvoice,
            status: statusFilter?.value || "",
            date_from: fromDate ? fromDate.format("YYYY-MM-DD") : "",
            date_to: toDate ? toDate.format("YYYY-MM-DD") : ""
        };

        const res = await Handler({ 
            method: "post", 
            url: "/invoice/man_exp_list.php", 
            data: payload 
        });

        if (res?.success) {
            setData(res?.data || []);
            setTotal(res?.pagination?.total_rows || 0);
            setOverallSum(res?.overall_total_expense || 0);
        } else {
            toast.error(res?.message || "Failed to load expenses");
        }
        dispatch(loadingFalse());
    };

    useEffect(() => {
        loadInvoices();
    }, [page, statusFilter]);

    const handleSearch = () => {
        setPage(1);
        loadInvoices();
    };

    const resetFilters = () => {
        setSearchInvoice("");
        setStatusFilter(null);
        setFromDate(null);
        setToDate(null);
        setPage(1);
        loadInvoices();
    };

    return (
        <div className="page-card p-4 bg-white rounded-4 shadow-sm">
            <div className="page-header d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
                <div>
                    <h4 className="fw-bold mb-0 text-dark">Overall Expenses List</h4>
                    <p className="text-muted small mb-0 text-uppercase letter-spacing-1">View all manual invoice expenditures</p>
                </div>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        {/* Overall Sum Display Badge */}
                        <Badge color="soft-danger" className="text-danger bg-danger bg-opacity-10 px-3 py-2 fs-6 rounded-pill border border-danger border-opacity-25 me-2">
                            Total: ${overallSum.toFixed(2)}
                        </Badge>
                        
                        <input
                            type="text"
                            placeholder="Invoice #..."
                            className="form-control form-control-sm shadow-none"
                            style={{ width: 140 }}
                            value={searchInvoice}
                            onChange={e => setSearchInvoice(e.target.value)}
                        />
                        <div style={{ width: 150 }}>
                            <DatePicker
                                label="From"
                                value={fromDate}
                                onChange={(val) => setFromDate(val)}
                                slotProps={{ textField: { size: "small" } }}
                            />
                        </div>
                        <div style={{ width: 150 }}>
                            <DatePicker
                                label="To"
                                value={toDate}
                                onChange={(val) => setToDate(val)}
                                slotProps={{ textField: { size: "small" } }}
                            />
                        </div>
                        <Button color="primary" size="sm" className="px-3 rounded-3 shadow-sm" onClick={handleSearch}>Search</Button>
                        <Button color="light" size="sm" className="px-3 rounded-3 border" onClick={resetFilters}>Reset</Button>
                    </div>
                </LocalizationProvider>
            </div>

            <div className="table-responsive">
                <table className="table modern-table align-middle">
                    <thead className="table-light">
                        <tr>
                            <th className="py-3">Date</th>
                            <th className="py-3">Type</th>
                            <th className="py-3">Customer & Invoice</th>
                            <th className="py-3">Remarks</th>
                            <th className="text-end py-3">Amount</th>
                            {/* <th className="text-center py-3">Action</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr><td colSpan="6" className="text-center py-5 text-muted">No expense records found</td></tr>
                        ) : data?.map((row) => (
                            <tr key={row.id}>
                                <td className="small">{dayjs(row.expense_date).format("DD-MM-YYYY")}</td>
                                <td>
                                    <Badge color="soft-info" className="text-info bg-info bg-opacity-10 text-uppercase px-2 py-1">
                                        {row.expense_type}
                                    </Badge>
                                </td>
                                <td>
                                    <div className="fw-semibold text-dark">{row.customer_name}</div>
                                    <div className="extra-small text-primary fw-bold">{row.invoice_number}</div>
                                </td>
                                <td className="small text-muted" style={{ maxWidth: '200px' }}>
                                    <div className="text-truncate" title={row.remarks}>{row.remarks || '-'}</div>
                                </td>
                                <td className="text-end fw-bold text-danger">
                                    -${parseFloat(row.amount || 0).toFixed(2)}
                                </td>
                                {/* <td className="text-center">
                                    <Button
                                        color="primary"
                                        size="sm"
                                        outline
                                        className="btn-icon rounded-3 px-2 py-1"
                                        onClick={() => navigate(`/invoice/execution?id=${row.invoice_id}`)}
                                        title="View Invoice Details"
                                    >
                                        <i className="bi bi-eye-fill"></i>
                                    </Button>
                                </td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="mt-4 border-top pt-3">
                <Pagination
                    page={page}
                    total={total}
                    limit={limit}
                    onPrev={() => setPage(p => Math.max(1, p - 1))}
                    onNext={() => setPage(p => p + 1)}
                />
            </div>
        </div>
    );
};

export default ManualInvoiceList;